import { Pipe, PipeTransform } from '@angular/core';
import {ProjectReferenceDetailResponse} from '../models/project-reference-detail.response';

@Pipe({
    name: 'locationStreetFormat',
    standalone: false
})
export class LocationStreetFormatPipe implements PipeTransform {

  transform(value: ProjectReferenceDetailResponse): string {
      let output = "";
      if (value.street !== null) {
          output += value.street
          if (value.houseNumber !== null) {
              output += ` ${value.houseNumber}`
          }
      }

      if (value.postCode !== null) {
          output += (output.length === 0) ? value.postCode : `, ${value.postCode}`
      }

      return output;
  }

}
